import {ResolvedAskUser} from '../ResolvedAskUser'
import type {ElicitationItem} from '../../../types/events'

/**
 * Renders a resolved elicitation prompt in the timeline.
 * Delegates to ResolvedAskUser for consistent expand/collapse behavior.
 */
export function Elicitation({item}: {item: ElicitationItem}) {
  if (!item.completedEvent) return null

  const action = item.completedEvent.data.action
  const content = item.completedEvent.data.content

  let resolvedAnswer: string | undefined

  switch (action) {
    case 'accept':
      resolvedAnswer = content
        ? Object.entries(content)
            .map(([key, value]) => `${key}: ${String(value)}`)
            .join(', ')
        : 'Accepted'
      break
    case 'decline':
      resolvedAnswer = 'Declined'
      break
    case 'cancel':
      resolvedAnswer = 'Cancelled'
      break
    default:
      resolvedAnswer = 'Resolved'
      break
  }

  return <ResolvedAskUser question={item.message} resolvedAnswer={resolvedAnswer} />
}
